import Backbone from 'backbone';

import * as context from 'Context';
import {Model as Selectable} from 'molbio/maps/selectables/Selectables';

abstract class SelectableView<M extends Backbone.Model = Backbone.Model> extends Backbone.View<M> {
  abstract isLinear: boolean;

  abstract clickAction(e: MouseEvent, d: Selectable): void;

  abstract dblClickAction(e: MouseEvent, d: Selectable): void;

  shouldCaptureLeftClick(): boolean {
    return true;
  }

  shouldCaptureDoubleClick(): boolean {
    return true;
  }

  pieceClickHandler(e: MouseEvent, d: Selectable): void {
    context.using({isLinear: this.isLinear, mapId: this.model.cid}, this, () => {
      this.clickAction(e, d);
    });
  }

  pieceDblClickHandler(e: MouseEvent, d: Selectable): void {
    context.using({isLinear: this.isLinear, mapId: this.model.cid}, this, () => {
      this.dblClickAction(e, d);
    });
  }
}

export default SelectableView;
